import { createApp } from 'vue';
import App from './App.vue';
import { i18n } from './i18n';
import router from './router';
import { store, key } from './store';
import VSelect from './components/GUI/Select.vue';
import VCheckBox from './components/GUI/CheckBox.vue';
import VDataTable from './components/GUI/DataTable.vue';
import VInput from './components/GUI/Input.vue';
import VAlert from './components/GUI/Alert.vue';
import VTextarea from './components/GUI/Textarea.vue';
import VRadio from './components/GUI/Radio.vue';
import VScrollableMenu from './components/GUI/ScrollableMenu.vue';

createApp(App).use(router)
    .use(store, key)
    .use(i18n)
    .component('v-select', VSelect)
    .component('v-input', VInput)
    .component('v-checkbox', VCheckBox)
    .component('v-datatable', VDataTable)
    .component('v-scrollable-menu', VScrollableMenu)
    .component('v-alert', VAlert)
    .component('v-textarea', VTextarea)
    .component('v-radio', VRadio)
    .mount('#app')